var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-x-3-lg m-x-2-md m-y-2-md"},[_c('span',{staticClass:"titulo-seccion"},[_vm._v("Prácticas específicas del MEIA")]),_c('h1',{staticClass:"titulo"},[_vm._v("Mapa uso de maquinaria 2007")]),_c('MapaUsoMaquinaria',{staticClass:"m-t-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }